export const CHANNEL_LOGOUT = 'channel-logout'
export const NOTIFICATION_RECEIVED = 'notification-received'
